module.exports = __webpack_public_path__ + "img/img3_icon.3f2d2123.png";